import {Pipe, PipeTransform} from '@angular/core';

type IOptions = {
  totalItems?: number, // Tổng số bản ghi
  rowId?: number | string, // Bản ghi ở từng dòng
}

@Pipe(
  {
    name: 'checkedSelection',
    standalone: false,
  }
)
export class CheckedSelectionPipe implements PipeTransform {

  transform(selectedIds: any[], opts: IOptions): boolean {

    // Check checked all
    if (opts?.totalItems) {
      if (!opts.totalItems) {
        return false;
      }
      return selectedIds.length === opts.totalItems;
    } else if (opts?.rowId) {
      // Check one record
      if (!opts.rowId) {
        return false;
      }
      return selectedIds.includes(opts.rowId as never)
    }

    return false;
  }
}
